import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AuthUser } from "@app/auth/model/auth-user";
import { ProjectView, ProjectViewHelper } from "@app/project/model/project-view";
import { ROLE_NAMES } from "@app/user/model/user-role";

@Component({
    selector: "app-project-views-list",
    templateUrl: "./project-views-list.component.html",
    styles: [".actions,.clare-column-select{ margin-left: 16px; }"],
})
export class ProjectViewsListComponent {
    @Input() allViews: ProjectView[];
    @Input() activeViewId: number;
    @Input() config: { entityId: number; userId: number; authUser: AuthUser };
    @Output() onEditProjectView = new EventEmitter();
    @Output() onProjectViewChange = new EventEmitter();

    trackById(_: number, item: ProjectView) {
        return !!item?.id;
    }

    changeProjectView() {
        this.onProjectViewChange.emit(
            this.allViews.find(view => view.id === +this.activeViewId) || ProjectViewHelper.getDefaultViewForRole(this.config.authUser)
        );
    }

    editProjectView() {
        // this.onEditProjectView.emit(
        //     this.allViews.find(view => view.id === +this.activeViewId) ||
        //         ProjectViewHelper.getDefaultProjectView(this.config.entityId, this.config.userId)
        // );
        this.onEditProjectView.emit(this.getCurrentView());
    }

    private getCurrentView() {
        const pmRoles: string[] = [ROLE_NAMES.PROPERTY_MANAGER_COORDINATOR, ROLE_NAMES.PROPERTY_MANAGER_ADMIN];
        if (+this.activeViewId) {
            return this.allViews.find(view => view.id === +this.activeViewId);
        }
        if (pmRoles.includes(this.config.authUser?.role.name)) {
            const userRole = this.config.authUser.role.name;
            return ProjectViewHelper.getPropertyManagerView(
                this.config.entityId,
                this.config.userId,
                userRole === ROLE_NAMES.PROPERTY_MANAGER_ADMIN
            );
        }
        return ProjectViewHelper.getDefaultProjectView(this.config.entityId, this.config.userId);
    }
}
